import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// Імпорти зображень
import providerIconAmatic from '../static/img/icon-provider/amatic-icon.png';
import providerIconAbsolute from '../static/img/icon-provider/absolute-live-gaming-icon.png';


import Game from '../../../class/Game/Game';
import Games from '../../../class/Game_copy/Game';

import AuthServices from '../../../class/services/AuthService';


// Дані про провайдерів та їхні ігри




import ModalGame from '../modal/modal_game';

import ALL_PROVIDERS from '../modal/all_providers';

import LOAD_GAMES_BY_PROVIDER_ID from '../modal/load_games_by_provider_id';

const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;

const providers = [
  {
    providerIcon: "/assets/img/icon-provider/amatic-icon.png",
    provider_name: 'Evolutions',
    gamesCount: 100,
    games: [
      {
        gameName: 'Inserire qui nome gioco',
        gameImageSrc: 'https://app.gamesolutions.org/xtudobet/es-content/uploads/Games/evolution-live-lobby.png',
      },
      {
        gameName: 'Inserire qui nome gioco',
        gameImageSrc: 'https://app.gamesolutions.org/xtudobet/es-content/uploads/Games/evolution-live-lobby.png',
      },
      {
        gameName: 'Inserire qui nome gioco',
        gameImageSrc: 'https://app.gamesolutions.org/xtudobet/es-content/uploads/Games/evolution-live-lobby.png',
      }
    ]
  },
  {
    providerIcon: "/assets/img/icon-provider/absolute-live-gaming-icon.png",
    provider_name: 'Evolutions',
    gamesCount: 100,
    games: [
      {
        gameName: 'Inserire qui nome gioco',
        gameImageSrc: 'https://app.gamesolutions.org/xtudobet/es-content/uploads/Games/evolution-live-lobby.png',
      },
      {
        gameName: 'Inserire qui nome gioco',
        gameImageSrc: 'https://app.gamesolutions.org/xtudobet/es-content/uploads/Games/evolution-live-lobby.png',
      },
      {
        gameName: 'Inserire qui nome gioco',
        gameImageSrc: 'https://app.gamesolutions.org/xtudobet/es-content/uploads/Games/evolution-live-lobby.png',
      }
    ]
  }
];

// Компонент для відображення ігор провайдера
const ProviderGameCard = ({ gameName, gameImageSrc, isBlurred, onGameClick }) => (
  <div
    className="HomeSectionCasinoGames_game p-1 mb-1"
    style={{
      filter: isBlurred ? 'blur(8px)' : 'none',
      transition: 'filter 0.3s ease',
      cursor: isBlurred ? 'not-allowed' : 'pointer',
    }}
    onClick={!isBlurred ? onGameClick : null} // Тільки якщо гра не заблюрена
  >
    <div className="CasinoGameCard_root">
      <div className="CasinoGamePreview_root">
        <div className="CasinoGamePreview_gradient"></div>
        <img className="ResponsivePicture_img CasinoGamePreview_image" src={gameImageSrc} alt={gameName} loading="lazy" />
      </div>
      <p className="titleGame_provider">{gameName}</p>
    </div>
  </div>
);



// Компонент для відображення провайдера
const GameProviderCard = ({
  providerIcon,
  provider_name,
  gamesCount,
  games = Array(4).fill({ isBlurred: true }),
  openGameModal,
  openAllProvidersModal,
  slug,
  getProviderIcon
}) => (
  <div className="HomeSectionCasinoGames_game GameProvider_content">
    <div className="header_GameProvider">
      <div className="Title_GameProvider">
        <img src={getProviderIcon(slug)} alt={provider_name} />
        <h3>
          {provider_name}
          <br />
          <small>{gamesCount} Giochi</small>
        </h3>
      </div>
      <a href="#" onClick={openAllProvidersModal}></a>
    </div>
    <div className="content_gameProvider">
      {/* Відображення ігор із пропсу games */}
      {games.map((game, index) => (
        <ProviderGameCard
          key={index}
          gameName={game.gameName || 'Loading...'}
          gameImageSrc={game.gameImageSrc || ''}
          isBlurred={game.isBlurred}
          onGameClick={() => openGameModal(game.id)} 
        />
      ))}
    </div>
  </div>
);



const ProviderList = ({game_slugs,limit,casinoSections,isLogged,setIsLoginModalOpen}) => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);

  const {t} = useTranslation();

  const [showGameModal, setShowGameModal] = useState(false); 
  const [selectedGameId, setSelectedGameId] = useState(null); 

  const [showAllProviders, setShowAllProviders] = useState(false);

  const [selectedProvider, setSelectedProvider] = useState(null);
  const [showGamesModal, setShowGamesModal] = useState(false);

      const openAllProvidersModal = () => {
        setShowAllProviders(true); 
    };

    const closeAllProvidersModal = () => {
        setShowAllProviders(false); 
    };


    const openSingleProvidersModal = (provider) => {
      setSelectedProvider(provider);
      setShowGamesModal(true);
    };
    
    const closeGamesModal = () => {
      setSelectedProvider(null);
      setShowGamesModal(false);
    };

    const getProviderIcon = (providerslug) => {
      return `${cmsUrl}static-assets/providers/${providerslug}.png`;
  };
  

  // Завантаження даних про провайдерів
  useEffect(() => {
    const fetchProviders = async () => {
      try {
        if(!casinoSections) { return; }
        const user_id = AuthServices.getCustom('user_id') || '';

        // const providerData = await Games.getProviders(user_id, "casino");
        // const decryptedData = providerData.params.providers || [];

        const results = await Promise.all(
          game_slugs.map(slug => Games.getProviders(user_id, slug))
        );

        const decryptedData = results.flatMap(
          result => result.params.providers || []
        );


        const transformedProviders = decryptedData.map((provider) => ({
          providerIcon: provider.slug || "/assets/img/icon-provider/amatic-icon.png",
          provider_name: provider.name,
            category_id: provider.category_id,
            slug: provider.slug,
            gamesCount: provider.active_games,
          providerId: provider.id, 
            games: Array(4).fill({ isBlurred: true }) 
        }));


        transformedProviders.map(async (provider, index) => {
          try {
            const gamesData = await Games.getProviderGame('', provider.providerId, 4, 1);
          
            const games = gamesData?.params?.games.map((game) => ({
              gameName: game.name,
              gameImageSrc: game.thumbnail || '',
              isBlurred: false,
              id: game.id
            })) || [];

            setProviders((prevProviders) => {
              const updatedProviders = [...prevProviders];
              updatedProviders[index] = { ...updatedProviders[index], games };
              return updatedProviders;
            });

          } catch (error) {
            console.error(`${t('Error_fetching_games')}:`, error);
          }
        });
      

        setProviders(transformedProviders);
      } catch (error) {
        console.error(`${t('Error_fetching_providers')}:`, error);
      } finally {
        setLoading(false);
      }
    };

    if(casinoSections){
      fetchProviders();
    }
  }, [casinoSections]);


  useEffect(() => {
    const fetchGamesForProviders = async () => {
      await Promise.all(
        providers.map(async (provider, index) => {
          try {
            const gamesData = await Games.getProviderGame('', provider.providerId, 4, 1);
          
            const games = gamesData?.params?.games?.map((game) => ({
              gameName: game.name,
              gameImageSrc: game.thumbnail || '',
              isBlurred: false,
              id: game.id
            })) || [];

            setProviders((prevProviders) => {
              const updatedProviders = [...prevProviders];
              updatedProviders[index] = { ...updatedProviders[index], games };
              return updatedProviders;
            });
          } catch (error) {
            console.error(`${t('Error_fetching_games')}:`, error);
          }
        })
      );
    };

    if (!loading) {
      fetchGamesForProviders();
    }
  }, [loading]);

  if (loading) {
    return <div>{t('loading')}...</div>;
  }

  const openGameModal = (gameId) => {
    
    setSelectedGameId(gameId); 
    setShowGameModal(true); 
  };


  const closeGameModal = () => {
    setShowGameModal(false); 
    setSelectedGameId(null); 
  };

  return (
    <div className="body main-layout-item provider_listScroll">
      <div className="Home_root">
        <div className="Home_games">
          <div  className="Home_header">
            <a href="#" className="HomeSection_header">
              <div className="HomeSection_label">{t('Providers')}</div>
              <div className="HomeSection_right">
                <div className="HomeSection_headerLink" onClick={openAllProvidersModal}>{t('All')}</div>
                <div className="HomeSection_caption">{providers.length} {t('Providers')}</div>
              </div>
            </a>
          </div>
          <div className="HomeSectionCasinoGames_list">
            {providers.map((provider, index) => (
              <GameProviderCard
                key={index}
                providerIcon={provider.providerIcon}
                provider_name={provider.provider_name}
                category_id={provider.category_id}
                gamesCount={provider.gamesCount}
                games={provider.games}
                slug={provider.slug}
                openGameModal={openGameModal}
                openAllProvidersModal={() => openSingleProvidersModal(provider)}
                getProviderIcon={getProviderIcon}
              />
            ))}
          </div>
        </div>
      </div>
      {showGameModal && ( 
        <ModalGame show={showGameModal} handleClose={closeGameModal} game_id={selectedGameId} />
      )}

        {showAllProviders && (
                    <ALL_PROVIDERS
                      AuthServices={AuthServices}
                      onClose={closeAllProvidersModal} 
                      casinoSections={casinoSections}
                      isLogged={isLogged}
                      setIsLoginModalOpen={setIsLoginModalOpen}

                    />
                )}



      {showGamesModal && (
        <LOAD_GAMES_BY_PROVIDER_ID
          Game={Games}
          user_id={AuthServices.getCustom('user_id') || ''}
          provider_id={selectedProvider?.providerId}
          category_id={selectedProvider?.category_id}
          onClose={closeGamesModal}
          isLogged={isLogged}
          setIsLoginModalOpen={setIsLoginModalOpen}
          provider_name={selectedProvider?.provider_name}
          provider_slug={selectedProvider?.slug}
        />
      )}

    </div>
  );
  
};

export default ProviderList;
